<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { computed } from 'vue';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface Props {
    title?: string;
    class?: HTMLAttributes['class'];
}

const props = defineProps<Props>();

const className = computed(() => props.class);
</script>

<template>
    <Card :class="className">
        <CardHeader v-if="title || $slots.header" class="pb-3">
            <slot name="header">
                <CardTitle v-if="title">{{ title }}</CardTitle>
            </slot>
        </CardHeader>
        <CardContent>
            <slot />
        </CardContent>
    </Card>
</template>
